<template>
  <div class="navbar fr ac jc">
    <div class="navbar_content fr ac jsb">
      <div class="cont_left fz14 fr ac white">
        <span class="cursor" @click="go('/home/index')">欢迎来到益发商城！</span>
        <p v-if="!$store.state.is_login" class="text cursor" @click="go('/login')">请 登录 注册</p>
        <p v-if="$store.state.is_login" class="text cursor" @click="exit">退出</p>
      </div>
      <div class="cont_right fz14 fr ac white">
        <p class="cursor" v-if="hasPermission(907)" @click="go('/home/shopcart')">购物车</p>
        <p class="cursor" @click="go('/me/entrance')">个人中心</p>
        <p class="cursor" @click="go('/collection')" v-if="hasPermission(8)">我的收藏</p>
        <el-badge is-dot class="ml20 cursor" v-if="hasPermission(1) && false" @click.native="go('/me/message')" :hidden="sum">
          我的消息
        </el-badge>
        <p class="cursor">联系客服</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberInfo: "",
      sum: true
    };
  },
  created() {
  },
  mounted() {
    this.memberInfo = this.$store.state.memberInfo;
  },
  watch: {},
  methods: {
    exit() {
      this.$store.commit('setSaleInfo', null);
      this.$store.commit('setSalePermission_ids', null)
      this.$store.commit('setMemberInfo', null)
      // sessionStorage.setItem("memberInfo", null);
      this.go("/login");
    },
    getMemberMsgCount() {
      this.post("memberInterfaces/v1.0/getMemberMsgCount").then(res => {
        let sum = 0;
        sum += res.data.order_count;
        sum += res.data.send_count;
        sum += res.data.system_count;
        this.sum = !Number(sum);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.navbar {
  width: 100%;
  background-color: #458ef6;

  .navbar_content {
    width: 1200px;
    height: 40px;

    .cont_left {
      .text {
      }
    }

    .cont_right {
      p {
        margin-left: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue